/**
 * Assert function used to verify a given condition. Throws an error if the condition is false
 *
 * @param condition The condition to validate
 * @param message The message used in the Error when the condition is false
 */
export function assert(condition: any, message?: string): asserts condition {
  if (!condition) {
    throw new Error(message ?? "Assertion failed");
  }
}
